module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Death-Of-Stalin-The.c1056a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Death-Of-Stalin-The.jpg
// module id = V9UY
// module chunks = 0